import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '@config/environments/environment';
import { WEB_ROUTE_SSO_XAC_MINH_LAN_DAU } from '@features/auth/const';
import { AuthSSOService } from '@features/auth/core/domain/sso-auth/auth-sso-web.service';
import { AuthService } from '@features/auth/public-api';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
import { getBackLinkToken, isExistBackLink, navigateToBackLink, navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  selector: 'app-sso-finished-form',
  templateUrl: './finished-form.component.html',
  styleUrls: ['./finished-form.component.css'],
})
export class SSOFinishedFormComponent {
  router = inject(Router);
  private readonly authService = inject(AuthSSOService);

  onNavigateToHome() {
    // Check to to
    navigateToBackLink(this.router, 'authen_code');
  }

  navigateToLogin() {
    // this.router.navigateByUrl(WEB_ROUTE_SSO_XAC_MINH_LAN_DAU);
    navigateWithQueryParams(this.router, [WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
  }

  // TODO:
  onNavagateToSiteDaoTao() {
    window.location.href = environment.path.external_link.webDaoTao;
  }
}
